import type { ToastMessageOptions } from 'primevue'
import type { ToastServiceMethods } from 'primevue/toastservice'

let toastInstance: ToastServiceMethods | null = null

export const setToastInstance = (instance: ToastServiceMethods) => {
    toastInstance = instance
}

export const showToast = (msg: ToastMessageOptions) => {
    if (!toastInstance) {
        // eslint-disable-next-line no-console
        console.error('[ToastBus] Toast instance not set yet.')
        return
    }
    toastInstance.add(msg)
}
